<div class="flex layout-sidebar" observeSidebar (widthChanged)="onChangeSidebarWidth($event)">
  <div class="layout-sidebar-menu">
    <div class="layout-topbar-logo-container">
      <app-svg styleClass="h-[44px] w-[44px] rounded-lg" href="/assets/svg/menu/logo.svg" />
    </div>
    <div class="flex flex-col justify-between h-full">
      <div class="flex gap-4">
        <!-- Livello 1 -->
        <!-- <p-listbox
              [options]="menuRoot"
              optionLabel="label"
              (onChange)="onSelect($event.value, 0)"
              [style]="{ width: '100%' }"
            ></p-listbox> -->
        <ul class="layout-menu">
          <li class="layout-root-menuitem">
            <ul>
              <ng-container *ngFor="let item of initialModel; let i = index">
                <li>
                  <!-- Render routerLink items (no children) -->
                  <a
                    *ngIf="item.routerLink && !item.hasChildren && item.visible !== false"
                    [routerLink]="item.routerLink"
                    [ngClass]="item.styleClass"
                    [attr.target]="item.target"
                    tabindex="0"
                    pRipple
                    class="layout-menuitem-link"
                    routerLinkActive="active-route"
                    [routerLinkActiveOptions]="
                      item.routerLinkActiveOptions || {
                        paths: 'exact',
                        queryParams: 'ignored',
                        matrixParams: 'ignored',
                        fragment: 'ignored',
                      }
                    "
                  >
                    <app-svg styleClass="h-[20px] w-[20px]" href="{{ item.icon }}" />
                    <span class="layout-menuitem-text">{{ item.label ?? '' | translate }}</span>
                  </a>
                  <!-- Render items with children or just URL (no routerLink) just contents -->
                  <a
                    *ngIf="(!item.routerLink || item.hasChildren) && item.visible !== false"
                    [attr.href]="item.url"
                    [ngClass]="item.styleClass"
                    [attr.target]="item.target"
                    tabindex="0"
                    pRipple
                    class="layout-menuitem-link"
                    routerLinkActive="active-route"
                    (click)="onSelect(item, 0)"
                    [routerLinkActiveOptions]="
                      item.routerLinkActiveOptions || {
                        paths: 'exact',
                        queryParams: 'ignored',
                        matrixParams: 'ignored',
                        fragment: 'ignored',
                      }
                    "
                  >
                    <app-svg styleClass="h-[20px] w-[20px]" href="{{ item.icon }}" />
                    <span class="layout-menuitem-text">{{ item.label ?? '' | translate }}</span>
                  </a>
                  <div
                    *ngIf="(!item.routerLink || item.items) && item.visible !== false"
                    class="open-floating-button"
                    [style]="{ left: anchorBtnPx }"
                  >
                    <p-button
                      type="button"
                      pRipple
                      [icon]="showSubmenu ? 'pi pi-chevron-left' : 'pi pi-chevron-right'"
                      class="p-button-text p-button-plain"
                      (click)="onSelect(item, 0)"
                      [@slideInOut]
                    ></p-button>
                  </div>
                </li>
              </ng-container>
            </ul>
          </li>
        </ul>
      </div>

      <ul class="layout-menu">
        <ng-container *ngFor="let item of endModel; let i = index">
          <li app-menuitem *ngIf="!item.separator" [item]="item" [index]="i" [root]="true"></li>
          <li *ngIf="item.separator" class="menu-separator"></li>
        </ng-container>
      </ul>
    </div>
  </div>
  <ng-container *ngFor="let level of selectedLevels; let i = index">
    <div class="submenu" *ngIf="showSubmenu" [@slideInOut]>
      <p class="submenu-title">{{ level.label | translate }}</p>
      <app-submenu [item]="level" [level]="0" [expandedPath]="contentsExpandedPath" [currentId]="currentContentId" />
    </div>
  </ng-container>
</div>
<!-- Livelli successivi -->

<app-instant-feedback-dialog
  *ngIf="instantFeedbacksDetail() as detail"
  [detail]="detail"
  (submitFeedback)="onSubmitInstantFeedback()"
  (close)="onCloseInstantFeedback()"
></app-instant-feedback-dialog>

<open-feedback-create-dialog
  [(visible)]="displayOpenFeedbackDialog"
  (onHide)="onCloseOpenFeedback()"
  (feedbackSuccess)="onFeedbackSuccess()"
></open-feedback-create-dialog>

<success-modal
  [visible]="showSuccessModalFromOpenFeedback || showSuccessModal"
  [title]="dialogSuccessTitle"
  [message]="dialogSuccessMessage"
  [closeLabel]="dialogSuccessClose"
  (close)="onCloseSuccessModal()"
></success-modal>
